<template>
    <v-app :dark="isDarkTheme">
        <navbar />
        <v-content>
            <transition name="fade" mode="out-in" >
                <router-view :key="$route.path" />
            </transition>
        </v-content>
    </v-app>
</template>

<script>
import navbar from './Navbar'

export default {
    components: {
        navbar,
    },
    computed: {
        colorVariables () {
            return {
                '--background-color': this.$store.getters.backgroundColor,
                '--accent-color': this.$store.getters.accentColor,
                '--logo': this.$store.getters.logo,
            }
        },
        isDarkTheme () {
            return this.$store.getters.darkTheme
        },
        isLightTheme () {
            return !this.isDarkTheme
        },
    },
    watch: {
        '$store.getters.backgroundColor': {
            handler (value) {
                this.$vuetify.theme.primary = value
            },
            immediate: true,
        },
        '$store.getters.accentColor': {
            handler (value) {
                this.$vuetify.theme.accent = value
            },
            immediate: true,
        },
    },
    methods: {
        resizeListener () {
            /* https://css-tricks.com/the-trick-to-viewport-units-on-mobile/ */
            let vh = window.innerHeight * 0.01
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`)
        },
    },
    mounted () {
        this.resizeListener()
        window.addEventListener('resize', this.resizeListener)
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.resizeListener)
    },
}
</script>

<style>
.application--wrap {
    min-height: calc(var(--vh, 1vh) * 100) !important;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
